import { render } from "./LoginModule.vue?vue&type=template&id=52cedec2"
import script from "./LoginModule.vue?vue&type=script&lang=js"
export * from "./LoginModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__